import type { DocumentPointer } from '@allemnii-pulse/shared';
import { useDocument } from '../../lib/firestore.js';

/** Live PRD + TDD document pointers for one project — the same two reads ProjectOverviewPage
 * makes for its stage cards, shared here so the dashboard's stage-pipeline and
 * regeneration-impact widgets don't each duplicate the fetch. */
export function useProjectDocPointers(projectId: string) {
  const { data: prd, loading: prdLoading } = useDocument<DocumentPointer>(
    `projects/${projectId}/documents/prd`,
  );
  const { data: tdd, loading: tddLoading } = useDocument<DocumentPointer>(
    `projects/${projectId}/documents/tdd`,
  );
  return { prd, tdd, loading: prdLoading || tddLoading };
}

/** Total tasks across every status, from the project's denormalized counter — see
 * services/projects.ts (API) for how it's kept in sync. */
export function totalTaskCount(project: {
  counters?: { byStatus?: Record<string, number> };
}): number {
  const counts = project.counters?.byStatus;
  return counts ? Object.values(counts).reduce((sum, n) => sum + n, 0) : 0;
}
